import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { ServiceUserTeam, ServiceUserTeamAdd } from "@/api/types";

const teamsKey = (id: string) => ["service-users", id, "teams"] as const;

export function useServiceUserTeams(id: string) {
  return useQuery({
    queryKey: teamsKey(id),
    queryFn: () => api.GET<ServiceUserTeam[]>(`/service-users/${id}/teams`),
    enabled: Boolean(id),
  });
}

export function useAddServiceUserTeam(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: ServiceUserTeamAdd) =>
      api.POST<ServiceUserTeam>(`/service-users/${id}/teams`, payload),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: teamsKey(id) });
    },
  });
}

export function useRemoveServiceUserTeam(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (teamId: string) =>
      api.DELETE<void>(`/service-users/${id}/teams/${teamId}`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: teamsKey(id) });
    },
  });
}
